angular.module('FlexyBeautyApp.services')
    .factory('BookingSettings', [function () {
        return {
            MOVE_BOOKING: "moveBooking",
            UPDATE_DURATION: "updateDuration",
            CREATE_SALE: "createSale",
            DELETE_BOOKING: "deleteBooking",
            UPDATE_CUSTOMER: "updateCustomer",
            DELETE_SERVICE: "deleteService",
            ADD_SERVICE: "addService",
            MOVE_HR: "moveHR",
            UPDATE_PRICE: "updatePrice",
            UPDATE_DISCOUNT: "updateDiscount",
            MOVE_PR: "movePR",
            HR_REQUEST: "hrRequest",
            DUPLICATE_BOOKING : "duplicateBooking",
            COMMENT : "comment",
            DISPLAY_SALE : "displaySale"
        };
    }])

    .factory('BookingPartnerSettings', ['BasicAuthRole', function(BasicAuthRole) {
        let bookingPartnerSettings = {};

        bookingPartnerSettings[BasicAuthRole.LE_CISEAU_ROLE.role] = {
            moveBooking : false,
            updateDuration: false,
            createSale: true,
            deleteBooking : true,
            updateCustomer: false,
            deleteService: false,
            addService: false,
            moveHR: false,
            updatePrice : false,
            updateDiscount : false,
            movePR : false,
            hrRequest: false,
            duplicateBooking : true,
            comment : true,
            displaySale : true
        };

        bookingPartnerSettings[BasicAuthRole.GOOGLE_ROLE.role] = {
            moveBooking : true,
            updateDuration: true,
            createSale: true,
            deleteBooking : true,
            updateCustomer: false,
            deleteService: true,
            addService: true,
            moveHR: true,
            updatePrice : true,
            updateDiscount : true,
            movePR : true,
            hrRequest: true,
            duplicateBooking : true,
            comment : true,
            displaySale : true
        };

        return bookingPartnerSettings;
    }])

    .factory('BookingPartnerSettingsAdmin', ['BasicAuthRole', function(BasicAuthRole) {
        let bookingPartnerSettingsAdmin = {};

        bookingPartnerSettingsAdmin[BasicAuthRole.LE_CISEAU_ROLE.role] = {
            moveBooking : true,
            updateDuration: false,
            createSale: false,
            deleteBooking : true,
            updateCustomer: false,
            deleteService: false,
            addService: false,
            moveHR: false,
            updatePrice : false,
            movePR : false,
            hrRequest: false,
            duplicateBooking : false,
            comment : false,
            displaySale : true
        };

        return bookingPartnerSettingsAdmin;
    }])

    .factory('BookingPartnerSettingsFactory', ['BasicAuthRoleFactory', 'BookingPartnerSettings', 'BookingPartnerSettingsAdmin', 'BasicAuthRole',
        function (BasicAuthRoleFactory, BookingPartnerSettings, BookingPartnerSettingsAdmin, BasicAuthRole) {
        return {
            checkBookingPartnerSettings: function (setting, creator) {
                let checkBookingPartnerSettings = true;
                if (setting && creator) {
                    let basicAuth = BasicAuthRoleFactory.getBasicAuthByBookingCreator(creator);
                    if (basicAuth && BookingPartnerSettings[basicAuth.role]) {
                        checkBookingPartnerSettings = BookingPartnerSettings[basicAuth.role][setting];
                    }
                }
                return checkBookingPartnerSettings;
            },
            checkBookingPartnerSettingsAdmin: function (isAdmin, setting, creator) {
                let checkBookingPartnerSettings = false;
                if (isAdmin && setting && creator) {
                    let basicAuth = BasicAuthRoleFactory.getBasicAuthByBookingCreator(creator);
                    if (basicAuth && basicAuth.role === BasicAuthRole.LE_CISEAU_ROLE.role && BookingPartnerSettingsAdmin[basicAuth.role]) {
                        checkBookingPartnerSettings = BookingPartnerSettingsAdmin[basicAuth.role][setting];
                    }
                }
                return checkBookingPartnerSettings;
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/ConstantsBookingSettings.js